export default "__VITE_ASSET__CSGFH6yE__"